import styled from "styled-components"

export const Title = styled.div`
  font-size: 12px;
  color: #475569;
  margin: 10px 0 5px;
`
